import { z } from 'zod';

export const deviceSchema = z.object({
    isAvailable: z.boolean().optional(),
    usbVendorId: z.number().optional(),
    usbProductId: z.number().optional(),
    bluetoothServiceClassId: z.union([z.number(), z.string()]).optional(),
    label: z.string(),
});

export type Device = z.infer<typeof deviceSchema>;

export const knownDevicesSchema = z.array(deviceSchema);
